/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Intro, Controls, ControlGroup } from "components/containers";
import { Description, Title } from "components/typography";
import { Section, Wrapper } from "../styles";
import { fetchDocAssets } from "redux/actions/mktassets";
import AffiliateData from "utils/user-data";
import { ExportButton } from "components/buttons";
import DocAssetsTable from "components/tables/doc-assets";
import MainSelect from "components/main-select";

const DocA = () => {
  const dispatch = useDispatch();
  const loggedInAff = new AffiliateData();
  const { campaigns } = useSelector((state) => state.aff_campaigns);

  const options =
    campaigns === null
      ? []
      : campaigns.map((el) => ({ label: el.name, value: el.id }));

  useEffect(() => {
    dispatch(
      fetchDocAssets(
        {
          domain: loggedInAff.get().data.affiliate.domain,
          affId: loggedInAff.get().data.affiliate.id,
        },
        {}
      )
    );
  }, []);

  return (
    <Section>
      <Intro>
        <Title>PDF Documents</Title>
        <Description>
          These document have been provided to aid your content marketing. You
          can copy/paste their content into your blog or social media platforms
        </Description>
      </Intro>
      <Wrapper>
        <Controls
          style={{
            padding: "1em",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
          }}
        >
          {/* <ExportButton caption="Export Report" /> */}
          <ControlGroup>
            <MainSelect options={options} label={null} />
          </ControlGroup>
        </Controls>
        <DocAssetsTable />
      </Wrapper>
    </Section>
  );
};

export default DocA;
